import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=bc649fd2&scoped=true&lang=pug"
import script from "./LightBox.vue?vue&type=script&lang=ts"
export * from "./LightBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc649fd2",
  null
  
)

export default component.exports